import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { IAtgard } from "~app/features/planera/model/IAtgard";

export class ArbetsorderAtgardProduktionAvslutadRvValidation {

    static init(atgard: IAtgard): ValidationContext {
        const context = new ValidationContext();
        context.create(ValidationScopes.spara, ValidationErrorLevels.warning).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                message: { text: "Åtgärden utförd måste anges" },
                model: () => atgard.atgardUtford,
                name: "utford",
                required: true,
                triggerOnLoad: true
            },
            {
                applicable: () => atgard.grotuttagProduktionsplanerat && atgard.atgardUtford,
                errorLevel: ValidationErrorLevels.error,
                id: 2,
                message: { text: "Grotanpassad måste anges" },
                model: () => atgard.grotAnpassad,
                name: "grotanpassad",
                required: true,
                publish: true,
                verbose: true,
                triggerOnLoad: true
            },
            {
                applicable: () => atgard.atgardUtford && atgard.grotAnpassad,
                errorLevel: ValidationErrorLevels.error,
                id: 4,
                message: { text: "Grotvolym måste anges" },
                model: () => atgard.grotVolym,
                expression: (newValue) => ObjectUtils.stringHasValue(newValue) && +newValue !== 0,
                name: "grotvolym",
                subscriptions: [
                    "grotanpassad",
                    "utford"
                ],
                verbose: true,
                triggerOnLoad: true
            }
        ]);
        return context;
    }
}
